export const MOVEMENTS_QUERY_KEY = 'movements'
export const MOVEMENT_NUMBER_QUERY_KEY = 'movementNumber'
